export default "__VITE_ASSET__$fCZwHWs__"